import { render, staticRenderFns } from "./select_form.vue?vue&type=template&id=0e580b06&scoped=true"
import script from "./select_form.vue?vue&type=script&lang=ts"
export * from "./select_form.vue?vue&type=script&lang=ts"
import style0 from "./select_form.vue?vue&type=style&index=0&id=0e580b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e580b06",
  null
  
)

export default component.exports